import { message } from 'antd';
import React from 'react';
import SuccessImg from '../../images/success.png';
import ErrorImg from '../../images/error.png';
import WarningImg from '../../images/warning.png';
import InfoImg from '../../images/info.png';
import * as styles from './index.module.scss';
import useIsMobile from '@/hooks/useIsMobile';

export enum MessageType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

// 创建自定义的 message 封装函数
const customMessage = {
  success(content: React.ReactNode, duration = 2) {
    message.success(
      {
        content: content,
        icon: <img src={SuccessImg} alt="success" />,
        className: styles.message,
      },
      duration
    );
  },
  error(content: React.ReactNode, duration = 2) {
    message.error(
      {
        content: content,
        icon: <img src={ErrorImg} alt="error" />,
        className: styles.message,
      },
      duration
    );
  },
  info(content: React.ReactNode, duration = 2) {
    message.info(
      {
        content: content,
        icon: <img src={InfoImg} alt="info" />,
        className: styles.message,
      },
      duration
    );
  },
  warning(content: React.ReactNode, duration = 2) {
    message.warning(
      {
        content: content,
        icon: <img src={WarningImg} alt="warning" />,
        className: styles.message,
      },
      duration
    );
  },
};

export default customMessage;
